export const CardTabList = [
    {
        name: {
            'fa': 'ویدیو'
        }
    },
    {
        name: {
            'fa': 'معرفی'
        }
    },
]